<template>
  <div class="col-md-12">
    <div class="col-md-12 breadcumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/principal' }"
          >Home</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/mis_pedidos' }">
          {{ $t("app.modules.orders.title") }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          {{ $t("app.modules.orders.tracking.name") }}
        </el-breadcrumb-item>
        <h6 style="margin-bottom: 0px" class="text-right">{{ $t("app.welcome") }}  {{ this.$store.state.user.nombre }} </h6>
      </el-breadcrumb>
      <td class="col-11"></td>
          <td class="col-2"><h7 style="margin-bottom: 0px" class="text-right">{{ this.$store.state.user.cliente.razonSocial }}  </h7></td>
    </div>
    <div class="col-md-12">
      <h3>
        {{ $t("app.modules.orders.tracking.name") }}
      </h3>
    </div>
    <card>
      <div class="row">
        <div class="col-md-2 float-left">
          <b>{{ $t("app.modules.orders.headers.order_number") }}</b
          >:
          {{ this.pedido.numPedidoSAP }}
          <br />
          {{  $t(
                  "app.modules.orders.status." +
                    this.estadoPedido.get(this.pedido.idEstadoPedido)
                )
              }}
        </div>

        <div class="col-md-3 float-left">
          <b>{{ $t("app.modules.orders.headers.business_name") }}</b>:
          <br />
          {{ this.pedido.razonSocial }}
        </div>

        <div class="col-md-2 float-left">
          <b>{{ $t("app.modules.orders.headers.created_date") }}</b
          >:
          {{ this.pedido.fechaCreacionPedido }}
          <br />
          <b>{{ $t("app.modules.orders.headers.auth_date") }}</b
          >:
          {{ this.pedido.fechaConfirmacionPedido }}
        </div>
        
        <div class="col-md-3 float-left">
          <!--
          <b>{{ $t("app.modules.orders.headers.salesman") }}</b
          >:
          {{ this.pedido.vendedor }}
          <br />
          -->
          <b>{{ $t("app.modules.orders.headers.customer_service") }}</b
          >:
          {{ this.pedido.servicioCliente }}
          <br />
          <b>{{ $t("app.modules.orders.headers.customer_service") }}</b
          >:
          {{ this.pedido.usuarioCliente }}
        </div>

        <div class="col-md-2 float-left">
          <b>{{ $t("app.modules.orders.headers.purchase_order") }}</b> :
          <br />
          {{ this.pedido.ordenCompraCliente }}
        </div>
      </div>
    </card>
    <card>
      <div class="row" v-if="this.detail">
        <div class="col-3 float-left">
          <img :src="[server + this.detallePedido.imagenProducto]" />
        </div>
        <div class="col-3">
          <b>{{ $t("app.modules.orders.headers.product") }}:&nbsp;</b>
          {{ this.detail.codigoProducto }}
        </div>
        <div class="col-3">
          <b>{{ $t("app.modules.orders.headers.description") }}:&nbsp;</b>
          {{ this.detail.descripcionProducto }}
        </div>
        <div class="col-3">
          <b>{{ $t("app.modules.orders.headers.delivery_date") }}:&nbsp;</b>
          {{ this.detail.fechaEntregaSolicitada | formatDate }}
        </div>
        <div class="col-3">
          <b>{{ $t("app.modules.orders.headers.delivery_address") }}:&nbsp;</b>
          {{ this.detail.direccionEntrega }}
        </div>
        <div class="col-3">
          <b>{{ $t("app.modules.orders.headers.quantity") }}:&nbsp;</b>
          {{ this.detail.cantidad | numFormat }} {{ this.detail.unidadMedida }}
        </div>
        <div class="col-3">
          <b>{{ $t("app.modules.orders.headers.price") }}:&nbsp;</b>
          {{ this.detail.precioUnitario | numFormat('0,0.0000') }} {{ this.detail.moneda }}
        </div>
        <div class="col-3">
          <b>{{ $t("app.modules.orders.headers.total") }}:&nbsp;</b>
          {{ this.detail.subTotal | numFormat('0,0.00') }} {{ this.detail.moneda }}
        </div>
      </div>
    </card>
    <div
      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <time-line v-if="this.tracking.length">
        <time-line-item
          :badge-type="getIconColor(tra)"
          :badge-icon="tra.type === 0 ? 'now-ui-icons shopping_delivery-fast' : 'el-icon-warning-outline'"
          :inverted="tra.type === 0"
          v-for="(tra, traIndex) in this.tracking"
          :key="tra.idDetallePedido"
          :is-last="(traIndex+1) === tracking.length ? true : false"
        >
          <template v-if="tra.type === 0">
            <div slot="header" class="badge badge-info">
              {{ tra.fecha }}
            </div>
            <div slot="content">
              <div>{{ tra.fase_nombre }}</div>
              <div></div>
              <div></div>
            </div>
            <div slot="footer">
              {{ tra.transporte_nombre }}
              &nbsp;|&nbsp;
              {{ tra.transportista_nombre }}
              :&nbsp;
              {{
                $t(
                  "app.enums.fases_vals." +
                    fasesEntregaEnum.getValue(tra.faseEntrega)
                )
              }}
              <br />
              <br />
              <div v-if="tra.faseEntrega === fasesEntregaEnum.Entregada">
                          <b>{{ $t("app.modules.orders.tracking.received_by") }}:</b>
                          &nbsp;
                          {{ tra.personaEntrega }}
                          <br />
                          <br />
              </div>
              <div v-if="tra.faseEntrega === fasesEntregaEnum.Rechazada">
                          <b>{{ $t("app.modules.orders.tracking.rejected_by") }}:</b>
                          &nbsp;
                          {{ tra.personaEntrega }}
                          <br />
                          <br />
                          <b>{{ $t("app.modules.orders.tracking.rejected_reason") }}:</b>
                          &nbsp;
                          {{ tra.motivoRechazo }}
                          <br />
                          <br />
              </div>
              <div>
                <b>{{ $t("app.general.comments") }}:</b>
                &nbsp;
                {{ tra.comentario }}
              </div>
              <div v-if="tra.ubicacionAproximada.length > 0">
                <b>{{ $t("app.general.aprox_location") }}:</b>
                &nbsp;
                {{ tra.ubicacionAproximada }}
              </div>
            </div>
          </template>
          <template v-else>
            <div slot="header" class="badge badge-danger">
              {{ tra.fecha }}
            </div>
            <div slot="content">
              <div>{{ $t("app.modules.orders.tracking.tracking_incident") }}</div>
              <div></div>
              <div><b>{{ tra.fase_nombre }}</b></div>
              <br />
              <br />
            </div>
            <div slot="footer">
              <div>
                <b>{{ $t("app.general.comments") }}:</b>
                &nbsp;
                {{ tra.comentario }}
              </div>
              <div v-if="tra.ubicacionAproximada.length > 0">
                <b>{{ $t("app.modules.delivery.addIncidencia.locationDescription") }}:</b>
                &nbsp;
                {{ tra.ubicacionAproximada }}
              </div>
            </div>
          </template>
        </time-line-item>
      </time-line>
<!--      <br />
      <card>
        <div class="col-12 text-center badge badge-info">
          {{  $t(
                  "app.modules.orders.status." +
                    this.estadoPedido.get(this.pedido.idEstadoPedido)
                )
              }}
        </div>
      </card>-->
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import TimeLine from "@/components/Timeline/TimeLine.vue";
import TimeLineItem from "@/components/Timeline/TimeLineItem.vue";
import ConstFasesEntrega from "@/models/FasesEntrega/ConstFasesEntrega";
import { getResponse } from "@/util/utilities";
import moment from "moment";
import ConstEstadoPedido from '@/models/pedidos/ConstEstadoPedido';
import numeral from 'numeral'
import numFormat from 'vue-filter-number-format'

Vue.filter('numFormat', numFormat(numeral))

export default {
  components: {
    TimeLine,
    TimeLineItem,
  },
  data() {
    return {
      pedido: {},
      detallePedido: {},
      tracking: [],
      detail: [],
      fasesEntregaEnum: new ConstFasesEntrega(),
      server: "",
      estadoPedido: new ConstEstadoPedido(),
      tiposIncidencia: []
    };
  },
  created() {
    this.server = process.env.VUE_APP_API_ENDPOINT;
  },
  async mounted() {
    this.$swal.fire({
      title: this.$t("app.promps.wait"),
      html:
        '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
      showConfirmButton: false,
    });
    this.pedido = this.$store.state.order;
    // console.log(this.pedido);
    this.detallePedido = this.$store.state.detail;
    // console.log(this.detallePedido);
    await this.getIncidentTypes();
    await this.getTracking(this.detallePedido.idDetallePedido);
    await this.getDetail(this.detallePedido.idDetallePedido);
    this.$swal.close();
  },
  methods: {
    getIconColor (tra) {
      let color = 'info';
      if (tra) {
        color = tra.type === 0 ? 'info' : 'danger'

        if (tra.faseEntrega === this.fasesEntregaEnum.Entregada) {
          color = 'success'
        }

        if (tra.faseEntrega === this.fasesEntregaEnum.Rechazada) {
          color = 'danger'
        }
      }

      return color
    },
    async getDetail(id) {
      const params = {
        id: id,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };

      await this.$http
        .post(route("Pedidos/getPedidoDetalleWebId"), params)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              if (response.body.detalles.length > 0) {
                this.detail = response.body.detalles[0];
                console.log(this.detail);
              }
            } else {
              console.log(response.body);
              // this.processError(response.body)
            }
          },
          (error) => {
            console.error(error);
            // this.processError(error)
          }
        );
    },
    async getIncidentTypes(id) {
      await this.$http
        .get(route("Incidencias/getTiposIncidencia"))
        .then(
          async (response) => {
            if (response.body.code === 200) {
              if (response.body.tiposIncidencias.length > 0) {
                this.tiposIncidencia = response.body.tiposIncidencias;
                // console.log("Tipos incidencia: ", this.tiposIncidencia);
              }
            } else {
              console.log(response.body);
              // this.processError(response.body)
            }
          },
          (error) => {
            console.error(error);
            // this.processError(error)
          }
        );
    },
    async getTracking(id) {
      this.GetLastLocation(id);
      const params = {
        id: id,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };
      this.tracking = [];
      let request = await this.$http.post(
        route("PartidaTracking/getTrackingPartida"),
        params
      );
      let response = getResponse(request, null);

      let tracks = [];
      if (response) {
        tracks = response.tracking;
        console.log(tracks);
      } else {
        console.log(response);
      }

      let requestIncidencia = await this.$http.put(
        route("Incidencias/getIncidenciasByDetalle"),
        params
      );
      let responseIncidencia = getResponse(requestIncidencia, null);

      let incidencias = [];
      if (responseIncidencia && responseIncidencia.incidencias.length > 0) {
        incidencias = responseIncidencia.incidencias;
      }

      if (tracks.length > 0) {
        for (let t = 0; t < tracks.length; t++) {
          let track = tracks[t];
          let nextTrack = t + 1 < tracks.length ? tracks[t + 1] : null;

          let curDate = moment(track.fecha);
          let nextDate = nextTrack != null ? moment(nextTrack.fecha) : null;

          this.tracking.push({
            type: 0,
            idTracking: track.idDetallePedido,
            fase_nombre: track.fase_nombre,
            fecha: curDate.format("yyyy-MM-DD HH:mm"),
            transporte_nombre: track.transporte_nombre,
            transportista_nombre: track.transportista_nombre,
            faseEntrega: track.faseEntrega,
            comentario: track.comentario,
            ubicacionAproximada: track.ubicacionAproximada,
            personaEntrega: track.personaEntrega,
            motivoRechazo: track.motivoRechazo
          });

          if (incidencias.length > 0) {
            incidencias.forEach((i) => {
              let inciDate = moment(i.fechaIncidencia);

              if (
                (nextDate != null &&
                  inciDate >= curDate &&
                  inciDate < nextDate) ||
                (nextDate == null && inciDate >= curDate)
              ) {
                this.tracking.push({
                  type: 1,
                  idTracking: Math.random(),
                  fase_nombre: this.tiposIncidencia.filter(inc => inc.idTipoIncidencia == i.idTipoIncidencia)[0].nombre,
                  fecha: inciDate.format("yyyy-MM-DD HH:mm"),
                  transporte_nombre: "",
                  transportista_nombre: "",
                  faseEntrega: "",
                  comentario: i.detalleIncidencia,
                  ubicacionAproximada: "",
                  personaEntrega: "",
                  motivoRechazo: ""
                });
              }
            });
          }
        }
      }
    },
    async GetLastLocation(partidaId) {
      const params = {
        id: partidaId,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };
      await this.$http
        .post(route("PartidaTracking/getPartidaLasLocation"), params)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              var location = response.body.location;
              if (location) {
                this.lastLocation = {
                  lat: location.latitud,
                  lng: location.longitud,
                  title: location.created_at,
                };
              } else {
                this.lastLocation = null;
              }
            } else {
              console.log(response.body);
              // this.processError(response.body)
            }
          },
          (error) => {
            console.error(error);
            // this.processError(error)
          }
        );
    },
  },
  filters: {
    formatDate: function (date) {
      if (date !== "1990-01-01")
        return moment(new Date(date)).format("yyyy-MM-DD HH:mm");
      return "";
    },
  },
};
</script>

<style scoped>
.breadcumb {
  margin: 10px 0px 15px 0px;
}

.is-last {
  margin-bottom: -20px !important;
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,ffffff+25&0+0,1+25 */
  background: -moz-linear-gradient(top,  rgba(255,255,255,0) 0%, rgba(255,255,255,1) 25%); /* FF3.6-15 */
  background: -webkit-linear-gradient(top,  rgba(255,255,255,0) 0%,rgba(255,255,255,1) 25%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom,  rgba(255,255,255,0) 0%,rgba(255,255,255,1) 25%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */
}
</style>
